import Vue from 'vue'
import App from './App.vue'
import router from './router'
import SuiVue from 'semantic-ui-vue'
import ResponsiveByScaling from './utils/responisve-by-scaling'
import * as VueThreejs from 'vue-threejs'

import 'semantic-ui-css/semantic.min.css';

Vue.config.productionTip = false

Vue.use(SuiVue);
Vue.use(VueThreejs)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

//new ResponsiveByScaling ("app")
